import { render, staticRenderFns } from "./DataIndukRuangan.vue?vue&type=template&id=4b0cf63a"
import script from "./DataIndukRuangan.vue?vue&type=script&lang=js"
export * from "./DataIndukRuangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports